import React, { useState } from 'react';
import { Box, Typography, ToggleButtonGroup, ToggleButton, List, ListItem, ListItemText } from '@mui/material';

const TopProductTypes = ({ data }) => {
  const [metric, setMetric] = useState('quantity');

  const handleToggle = (event, newMetric) => {
    if (newMetric !== null) {
      setMetric(newMetric);
    }
  };

  // Ensure data exists and has the expected structure
  const chartDataSource = data?.quantity && data?.pieces ? data : { quantity: [], pieces: [] };

  // Sort data client-side based on the current metric, handle null values
  const sortedData = [...chartDataSource[metric]]
    .sort((a, b) => (b.total || 0) - (a.total || 0))
    .slice(0, 5);

  return (
    <Box sx={{ bgcolor: 'white', p: 4, borderRadius: 2, boxShadow: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'grey.800' }}>
          Top Product Types
        </Typography>
        <ToggleButtonGroup
          value={metric}
          exclusive
          onChange={handleToggle}
          size="small"
          sx={{
            '& .MuiToggleButton-root': {
              textTransform: 'none',
              fontWeight: 'medium',
              px: 2,
              py: 0.5,
            },
            '& .Mui-selected': {
              backgroundColor: '#2832C2',
              color: 'white',
              '&:hover': {
                backgroundColor: '#2832C2',
              },
            },
          }}
        >
          <ToggleButton value="quantity" > Quantity</ToggleButton>
          <ToggleButton value="pieces">Pieces</ToggleButton>
        </ToggleButtonGroup>
      </Box>
      {sortedData.length === 0 ? (
        <Typography sx={{ textAlign: 'center', color: 'grey.500', py: 4 }}>
          No data available
        </Typography>
      ) : (
        <List>
          {sortedData.map((item, index) => (
            <ListItem
              key={index}
              sx={{ display: 'flex', justifyContent: 'space-between', py: 1 }}
            >
              <ListItemText primary={item.name || 'Unknown'} />
              <Typography>{item.total || 0}</Typography>
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  );
};

export default TopProductTypes;